import request from '@/service/index'
import qs from 'qs'
import axios from 'axios'
import { ILoginData, IRegistInfo, IForgetInfo } from '@/@types/global'
const { NODE_ENV, VUE_APP_PROXY_PREFIX, VUE_APP_BASE_URL } = process.env
const baseURL = NODE_ENV === 'development' ? VUE_APP_PROXY_PREFIX : VUE_APP_BASE_URL
const service = axios.create({
    baseURL
})

export const getLoginRQ = (data: ILoginData) => {
  return request({
    url: '/Account/Login',
    method: 'POST',
    data: qs.stringify(data)
  })
}

export const getRegistRQ = (data: IRegistInfo) => {
  return request({
    url: '/Account/SignUp',
    method: 'POST',
    data: qs.stringify(data)
  })
}

export const getUserInfoRQ = () => {
  return request({
    url: '/account/GetCurrentInfo',
    method: 'GET'
  })
}

export const getForgetRQ = (data: IForgetInfo) => {
  return request({
    url: '/Account/ResetPwd',
    method: 'POST',
    data: qs.stringify(data)
  })
}

/**
 * @param { isReg } 1 验证邮箱是否已注册(用于重置密码)  , 0 不验证邮箱是否注册(用于注册)
 */
// interface ICaptchaParams {
//   email: string
//   isReg: number
// }
export const getCaptchaRQ = (data: any) => {
  return request({
    url: '/Account/VerifyEmail',
    method: 'POST',
    data: qs.stringify(data)
  })
}

export const ExitRQ = () => {
  return request({
    url: '/account/logout',
    method: 'GET'
  })
}
export const validKefuRQ = (data: any) => {
    return request({
        url: '/Account/KefuQuery',
        method: 'POST',
        data: qs.stringify(data)
    })
}

//生成充值订单
export const createChargeOrder = (data: any) => {
    return request({
        url: '/autoCharge/CreateChargeOrder',
        method: 'POST',
        data: qs.stringify(data)
    })
}
//开通会员订单
export const joinVIPOrder = () => {
    return request({
        url: '/autoCharge/CreateJoinVIPOrder',
        method: 'POST'
    })
}
//取消充值订单
export const cancelChargeOrder = (code: string) => {
    return request({
        url: '/autoCharge/CancelCHargeOrder?code=' + code,
        method: 'GET'
    })
}

//检测订单是否支付成功
export const checkChargeOrder = (code: string) => {
    return service.get('/autoCharge/GetkOrderStatus?code=' + code)
}

//获取充值优惠
export const getChargeGifts = () => {
    return service.get('/autoCharge/GetChargeGiftList')
}